import axios from "axios";
import { IResponse } from "../types/api";
import { IStats } from "../store/types";
import useStore from "../store";

export const useSongStats = () => {
    const setStats = useStore(state => state.setSongRequestStats);

    return async () => {
        const { data } = await axios.post<IResponse<IStats>>('/api/dashboard/stats', {}, {
            noAlert: true
        });

        setStats(data.result.songRequest);
    };
}